import {MutationTree} from "vuex";
import {ContractProfileTemplateState, ContractProfileTemplate} from "./model";

const mutations: MutationTree<ContractProfileTemplateState> = {
  setContractProfileTemplates(state, contractProfileTemplates: ContractProfileTemplate[]) {
    state.contractProfileTemplates = contractProfileTemplates;
  },
  addContractProfileTemplate(state, contractProfileTemplate: ContractProfileTemplate) {
    state.contractProfileTemplates.push(contractProfileTemplate);
  },
  updateContractProfileTemplate(state, contractProfileTemplate: ContractProfileTemplate) {
    const index = state.contractProfileTemplates.findIndex(c => c.id === contractProfileTemplate.id);
    if(index !== -1) {
      state.contractProfileTemplates.splice(index, 1, contractProfileTemplate);
    }
  },
  deleteContractProfileTemplate(state, id: string) {
    const index = state.contractProfileTemplates.findIndex(c => c.id === id);
    if(index !== -1) {
      state.contractProfileTemplates.splice(index, 1);
    }
  }
}

export default mutations;
